export default {
  data() {
    return {
      formAccess: {
        basic: {},
        char: {},
        relps: {},
        rev: {},
        select: {},
        stats: {},
        trans: {}
      },
      formCompany: {
        basic: {}, // database
        char: {}, // business
        pref: {}, // settings
        rev: {}, // revisions
        stats: {} // generate stats
      },
      formFacility: {
        basic: {}, // basic
        char: {}, // characteristics
        link: {}, // link / site information
        pref: {}, // pref
        rev: {}, // revision
        stats: {} // stats
      },
      formAsset: {
        basic: {}, // basic
        char: {}, // asset propoerties and char.
        link: {}, // link to others
        rev: {}, // document revisions
        stats: {} // stats, counter and dates
      },
      formAction: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formAttachment: {
        basic: {},
        char: {},
        stats: {}
      },
      formParts: {
        basic: {},
        char: {},
        stats: {}
      },
      formResources: {
        basic: {},
        char: {},
        stats: {}
      },
      formAnalysis: {
        basic: {},
        char: {},
        stats: {}
      },
      formRiskAssessment: {
        basic: {},
        char: {},
        stats: {}
      },
      formMaintActivity: {
        basic: {},
        char: {},
        stats: {}
      },
      formListEmbeddedItem: {
        basic: {},
        char: {},
        stats: {}
      },
      formResults: {
        basic: {},
        char: {},
        stats: {}
      },
      formLimits: {
        basic: {},
        char: {},
        stats: {}
      },
      formDocumentLog: {
        basic: {}, // documumnet log stats
        char: {}, // document log char
        rev: {}, // rev is copied from master document
        stats: {} // document log stats
      },
      formPermits: {
        basic: {},
        char: {},
        stats: {}
      },
      formTasks: {
        basic: {},
        char: {},
        stats: {}
      },
      formNotification: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {}
      },
      formWorkRequest: {
        basic: {},
        char: {},
        link: {}, // link
        rev: {},
        stats: {}, // stats
        trans: {} // transitions
      },
      formWorkCall: {
        basic: {}, // basic info
        char: {}, // characteristics
        link: {}, // link call
        rev: {}, // doc revision
        stats: {}, // stats
        trans: {} // transitions
      },
      formProcedure: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {}
      },
      formProgram: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {}
      },
      formOrder: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formEngineering: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formReport: {
        basic: {},
        char: {},
        link: {},
        stats: {},
        rev: {}
      },
      formEquipment: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {}
      },
      formMaterial: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {}
      },
      formMaterialList: {
        basic: {},
        char: {},
        part: {},
        rev: {},
        stats: {}
      },
      formRisk: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formRiskAnalysis: {
        basic: {},
        char: {},
        stats: {}
      },
      formIncident: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formPlan: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formMaintPlan: {
        basic: {},
        char: {},
        rev: {},
        link: {},
        trans: {},
        stats: {},
        strategy: {}
      },
      formMaintCall: {
        basic: {},
        char: {},
        rev: {},
        link: {},
        stats: {}
      },
      formMaintStrategy: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formBudget: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {},
        trans: {}
      },
      formHazard: {
        basic: {},
        char: {},
        link: {},
        rev: {},
        stats: {}
      },
      formMaintenanceAssurane: {
        basic: {},
        char: {},
        tech: {},
        rev: {},
        stats: {}
      },
      formMaintenanceStrategy: {
        basic: {},
        char: {},
        tech: {},
        rev: {},
        stats: {}
      },
      formMaintenancePlan: {
        basic: {},
        char: {},
        tech: {},
        rev: {},
        stats: {}
      },
      formMaintenanceCall: {
        basic: {},
        char: {},
        tech: {},
        rev: {},
        stats: {}
      }
    };
  }
};
